// Tenký fetch wrapper proti /api/*.
// V dev běží Vite proxy → :3040; v prod běží vše ze stejného origin přes nginx.

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

export async function api<T = unknown>(
  path: string,
  init?: RequestInit & { json?: unknown },
): Promise<T> {
  const headers = new Headers(init?.headers);
  let body = init?.body;
  if (init?.json !== undefined) {
    headers.set('Content-Type', 'application/json');
    body = JSON.stringify(init.json);
  }
  const res = await fetch(path.startsWith('/') ? path : `/api/${path}`, {
    ...init,
    headers,
    body,
    credentials: 'include',
  });
  const ct = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json() : await res.text();
  if (!res.ok) {
    // Globální 401 → na /login (kromě samotných auth endpointů, ať Login.tsx
    // může zpracovat „špatné heslo" nebo zjistit, že nikdo není přihlášen).
    if (
      res.status === 401 &&
      !path.startsWith('/api/auth') &&
      !path.startsWith('auth/') &&
      typeof window !== 'undefined' &&
      window.location.pathname !== '/login'
    ) {
      const from = window.location.pathname + window.location.search;
      window.location.assign(`/login?from=${encodeURIComponent(from)}`);
    }
    throw new ApiError(res.status, `API ${res.status} ${path}`, data);
  }
  return data as T;
}
